import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Principles from './components/Principles';
import Services from './components/Services';
import WhyNexit from './components/WhyNexit';
import Process from './components/Process';
import WorkingModels from './components/WorkingModels';
import FAQ from './components/FAQ';
import ContactCTA from './components/ContactCTA';
import ContactForm from './components/ContactForm';

export default function Home() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main>
        <Suspense fallback={<div className="min-h-screen bg-cream"></div>}>
          <Hero />
          <Principles />
          <Services />
          <WhyNexit />
          <Process />
          <WorkingModels />
          <FAQ />
          <ContactCTA />
          <ContactForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
